import { isBrowser } from '@websolutespa/bom-core';

declare global {
  interface Window {
    dataLayer?: Record<string, any>[];
  }
}

export function pushDataLayer(record: Record<string, any>) {
  if (isBrowser) {
    window.dataLayer?.push(record);
  }
}
